const EV_WLTP_RANGE = {
  uk: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
  fr: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
  de: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
};

export { EV_WLTP_RANGE };
